export class EventQueryParameters {
  // 2012-11-29	Limit to events occurring on or after the specified start time.	any	day/time
  starttime: string;
  // 2012-12-01	Limit to events occurring on or before the specified end time.	any	day/time
  endtime: string;
  // 46.8	Southern boundary.	-90°	degrees
  minlatitude: number;
  // 46.9	Northern boundary.	90°	degrees
  maxlatitude: number;
  // -122	Western boundary.	-180°	degrees
  minlongitude: number;
  // -121.5	Eastern boundary.	180°	degrees
  maxlongitude: number;
  // 40.0	Specify the central latitude point.	0.0	degrees
  lat: number;
  // 100.0	Specify the central longitude point.	0.0	degrees
  lon: number;
  // 5.0	Specify maximum distance from the geographic point defined by latitude and longitude.	180.0	degrees
  maxradius: number;
  // 1.0	Specify minimum distance from the geographic point defined by latitude and longitude.	0.0	degrees
  minradius: number;
  // -1	Limit to events with depths equal to or greater than the specified depth	any	float1 (km)
  mindepth: number;
  // 20	Limit to events with depths less than or equal to the specified depth	any	float1 (km)
  maxdepth: number;
  // -1.0	Limit to events with a magnitude larger than or equal to the specified minimum.	any	float
  minmag: number;
  // 8.3	Limit to events with a magnitude smaller than or equal to the specified maximum.	any	float
  maxmag: number;
  // magtype	M	Type of Magnitude used to test minimum and maximum limits. Case insensitive. ex. ML Ms mb Mw all preferred	preferred	text
  magnitudetype: number;
  // ISC	Specify the catalog from which origins and magnitudes will be retrieved (available catalogs)	NEIC PDE or ISC	text
  catalog: string;
  // NEIC PDE-Q	Limit to events contributed by a specified contributor (available contributors).	any2	text
  contributor: string;
  // 25	Limit the results to the specified number;  of events	unlimited	integer
  limit: number;
  // 20	Return results starting at the event count specified.	1	integer
  offset: number;
  // time–asc	Order results by time/ time-asc or magnitude/ magnitude-asc	time	text3
  orderby: string;
  // 2000-05-23	Limit to events updated after the specified time (useful for synchronizing events).	any	day/time
  updatedafter: string;
  // TRUE	Retrieve all magnitudes for the event, or only the primary magnitude. note	false	true/false
  includeallmagnitudes: boolean;
  // 1234	Retrieve an event based on the unique ID numbers assigned by the IRIS DMC4		text
  eventid: number;
  // text	Specify format. Valid formats include xml, text, and geocsv	xml	text5
  format: string;
  // 404	Specify which HTML Status code is returned when no data is found.6	204	204 or 404
  nodata: string;

  constructor() {
    this.format = 'text';
    this.nodata = '404';
    this.minmag = 0;
    this.orderby = 'time';
  }

  serialize(): string {
    const keyPairs = Object.keys(this)
      .map(key => {
        return key + '=' + this[key];
      });
    return '?' + keyPairs.join('&');
  }
}
